
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericMediumFilled as ObiVesselGenericMediumFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-medium-filled.js';
 
 
 

 
 export const ObiVesselGenericMediumFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-medium-filled',
   elementClass: ObiVesselGenericMediumFilledElement,
   events: {
     
   }
  });
 
 